import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Level3 = function Level3(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "3",
      y: "11",
      width: "3",
      height: "10",
      rx: "1.5",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "10",
      y: "7",
      width: "3",
      height: "14",
      rx: "1.5",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "17",
      y: "3",
      width: "3",
      height: "18",
      rx: "1.5",
      fill: color
    })]
  });
};
export default Level3;